import React from 'react';
import { FlagIcon } from 'lucide-react';
import { colors } from '../utils/colors';
interface PriorityFlagProps {
  level: 'low' | 'medium' | 'high' | 'critical';
  size?: 'sm' | 'md' | 'lg';
}
const PriorityFlag: React.FC<PriorityFlagProps> = ({
  level,
  size = 'md'
}) => {
  // Use the new color scheme for priority levels
  const getColor = () => {
    switch (level) {
      case 'low':
        return {
          bg: colors.ui.veryLightTeal,
          text: colors.primary.dark
        };
      case 'medium':
        return {
          bg: colors.ui.lightTeal,
          text: colors.primary.dark
        };
      case 'high':
        return {
          bg: colors.primary.light,
          text: colors.ui.white
        };
      case 'critical':
        return {
          bg: colors.primary.medium,
          text: colors.ui.white
        };
    }
  };
  const getSize = () => {
    switch (size) {
      case 'sm':
        return 'text-xs px-1.5 py-0.5';
      case 'lg':
        return 'text-sm px-3 py-1';
      default:
        return 'text-xs px-2 py-0.5';
    }
  };
  const colorStyle = getColor();
  return <div className={`rounded-full ${getSize()} font-medium inline-flex items-center`} style={{
    backgroundColor: colorStyle.bg,
    color: colorStyle.text
  }} data-id="element-92">
      <span className="mr-1" data-id="element-93">
        <FlagIcon className="w-3 h-3" data-id="element-94" />
      </span>
      <span className="capitalize" data-id="element-95">{level}</span>
    </div>;
};
export default PriorityFlag;